import { render, staticRenderFns } from "./LayoutNoauth.vue?vue&type=template&id=32dda145&"
import script from "./LayoutNoauth.vue?vue&type=script&lang=js&"
export * from "./LayoutNoauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports